/* eslint-disable @typescript-eslint/ban-ts-comment */
import __ from "web/Layout/Translations";

import logout from "web/utils/system/essentials/logout";

import classes from "./logout.scss";

const MainHeaderLogout = () => {
  const text = __("Wyloguj się");
  return (
    <button
      type="button"
      className={classes.root}
      title={text}
      // @ts-ignore
      onClick={logout}
      data-t1="logout_button"
    >
      {text}
    </button>
  );
};

export default MainHeaderLogout;
